import React, {Component} from 'react';
import './Sertifikalar.css';
import {Card, Col, Container, Row} from "react-bootstrap";
import Resin from "../img/1590003577120.jpg";
import Resim6 from "../img/1574764083454.jpg";
import Resume2 from "../img/free.png";
import Resim3 from "../img/s.png";
import Resim4 from "../img/1535491877540.png";
import Resume5 from "../img/1596208586197.jpg";
import { FiChevronsRight } from "react-icons/fi";
class Sertifikalar extends Component {
    render() {
        return (
            <div style={{alignItems:"center"}}>
            <Container style={{textAlign:"center"}}>
                <Row style={{textAlign:"center"}}>
                    <Col sm><Card  className="shadow p-3  bg-white rounded scale"  style={{ width: '18rem',marginTop:50,height:250,alignItems:"center"}}>
                        <Card.Body>
                            <Card.Title>Linkedin</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Become a FrontEnd Web Developer</Card.Subtitle>
                            <Card.Text>
                                <img src={Resin} alt="logo"  height={100}/>
                            </Card.Text>
                            <Card.Link style={{color:"black"}} href="https://drive.google.com/file/d/1FqNa55w3_lbQ0atvQfrqXQCiXUL0N-7t/view">Detaylar <FiChevronsRight/></Card.Link>
                        </Card.Body>
                    </Card>
                        <Card className="shadow p-3 mb-5 bg-white rounded scale" style={{ width: '18rem',marginTop:50,height:250  }}>
                        <Card.Body>
                            <Card.Title>Future Learn</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Learn to Code for the Web</Card.Subtitle>
                            <Card.Text>
                                <img src={Resume5} alt="logo"  height={100}/>
                            </Card.Text>
                            <Card.Link style={{color:"black"}} href="https://www.futurelearn.com/certificates/7j7yyty">Detaylar <FiChevronsRight/></Card.Link>
                        </Card.Body>
                    </Card>
                    </Col>
                    <Col sm>
                        <Card className="shadow p-3 mb-5 bg-white rounded scale" style={{ width: '18rem',marginTop:50,height:250 }}>
                        <Card.Body>
                            <Card.Title>Pirple</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Frontend Fundamentals</Card.Subtitle>
                            <Card.Text>
                                <img src={Resim4} alt="logo"  height={100}/>
                            </Card.Text>
                            <Card.Link style={{color:"black"}} href="https://www.credential.net/d5923926-0e32-44f9-a019-59d40b7d9342">Detaylar <FiChevronsRight/></Card.Link>

                        </Card.Body>

                    </Card>
                        <Card className="shadow p-3 mb-5 bg-white rounded scale" style={{ width: '18rem',marginTop:50,height:250,justifyContent:"center"  }}>
                        <Card.Body style={{marginTop:20}}>
                            <Card.Title>FreecodeCamp</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Responsive Web Design</Card.Subtitle>
                            <Card.Text>
                                <img src={Resume2} alt="logo"  height={75}/>
                            </Card.Text>
                            <Card.Link style={{color:"black"}} href="https://www.freecodecamp.org/certification/alicelebi/responsive-web-design">Detaylar <FiChevronsRight/></Card.Link>
                        </Card.Body>
                    </Card></Col>
                    <Col sm><Card className="shadow p-3 mb-5 bg-white rounded scale" style={{ width: '18rem',marginTop:50,height:250  }}>
                        <Card.Body style={{marginTop:20}}>
                            <Card.Title>Koç Üniversitesi</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Yapay Öğrenme Kış Okulu</Card.Subtitle>
                            <Card.Text>
                                <img src={Resim3} alt="logo"  height={75}/>
                            </Card.Text>
                            <Card.Link style={{color:"black"}} href="https://drive.google.com/file/d/1L186MKEPuC1sRLMvGYdlbYjAxjy8YLh_/view">Detaylar <FiChevronsRight/></Card.Link>
                        </Card.Body>
                    </Card>
                        <Card className="shadow p-3 mb-5 bg-white rounded scale" style={{ width: '18rem',marginTop:50,height:250  }}>
                        <Card.Body>
                            <Card.Title>Türkiye Siber Güvenlik Kümelenmesi</Card.Title>
                            <Card.Subtitle className="mb-2 text-muted">Linux 101 ve Sistem Yönetimi</Card.Subtitle>
                            <Card.Text>
                                <img src={Resim6} alt="logo"  height={75}/>
                            </Card.Text>
                            <Card.Link style={{color:"black"}} href="https://drive.google.com/file/d/1zujmADxrvg3-weI_Qm63TMEVUWpLXRdw/view">Detaylar <FiChevronsRight/></Card.Link>
                        </Card.Body>

                    </Card>
                    </Col>
                </Row>
            </Container>
            </div>

        );
    }
}

export default Sertifikalar;